import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { Advisor, RawAdvisorReview } from 'components/features/coaching/advisor/types/advisor'


export class GetTopAdvisorsAction extends createRequestAction<'GET_TOP_ADVISORS', void, Advisor[]>('GET_TOP_ADVISORS') {}
export class GetTopAdvisorsReviewsAction extends createRequestAction<'GET_TOP_ADVISORS_REVIEWS', void, RawAdvisorReview[]>('GET_TOP_ADVISORS_REVIEWS') {}

export type AdvisorLandingPageActions =
  | typeof GetTopAdvisorsAction.Type
  | typeof GetTopAdvisorsReviewsAction.Type
